import React from 'react';
import ContactInfoForm from 'shared/account-settings/components/ContactInfoForm';
import AccountSettings, {
  AccountSettingsTabComponent,
  Tab,
} from 'src/components/AccountSettings/AccountSettings';
import {SharedAccountSettings} from 'src/components/AccountSettings/AccountSettingsContext';
import {ACCOUNT_SETTING_ROUTES} from 'src/components/AccountSettings/utils/utils';
import CRUDService from '../../../src/services/CRUDService';
import {EDUCATOR_FIELDS} from '../actions/educator';
import {NOTIFICATION_SETTINGS} from '../actions/notification-settings';
import Colleagues from 'educator/account-settings/components/colleagues';
import TrustAndVerification from './trust-and-verification';
import ProfileForm from './profile-form';

export type EducatorAccountSettings = SharedAccountSettings & {
  _id: string;
  firstName: string;
  lastName: string;
  title: string;
  institution: object;
  websiteForEmployment?: string;
};

const SettingsService = new CRUDService<EducatorAccountSettings>('/v1/educators');

const tabs: Tab<EducatorAccountSettings>[] = [
  {
    ...ACCOUNT_SETTING_ROUTES.profile,
    component: function ProfileTab({
      settings: {_id, title, firstName, lastName},
      saveSettings,
    }: AccountSettingsTabComponent<EducatorAccountSettings>) {
      return (
        <ProfileForm
          _id={_id}
          initialValues={{_id, title, firstName, lastName}}
          onSubmit={saveSettings}
        />
      );
    },
  },
  {
    ...ACCOUNT_SETTING_ROUTES.contact,
    component: function ContactInfoTab({
      settings,
      saveSettings,
      setNavigationAnnouncement,
      ...props
    }: AccountSettingsTabComponent<EducatorAccountSettings>) {
      return (
        <ContactInfoForm
          initialValues={settings}
          // @ts-expect-error
          onSubmit={saveSettings}
          hideParentEmail={false}
          setNavigationAnnouncement={setNavigationAnnouncement}
          {...props}
        />
      );
    },
  },
  {
    ...ACCOUNT_SETTING_ROUTES['trust-and-verification'],
    component: function TrustAndVerificationTab({
      settings,
      saveSettings,
      ...props
    }: AccountSettingsTabComponent<EducatorAccountSettings>) {
      return <TrustAndVerification initialValues={settings} onSubmit={saveSettings} {...props} />;
    },
  },
  {
    ...ACCOUNT_SETTING_ROUTES.colleagues,
    component: function ColleaguesTab({
      settings,
      saveSettings,
      setNavigationAnnouncement,
      ...props
    }: AccountSettingsTabComponent<EducatorAccountSettings>) {
      return (
        <Colleagues
          // @ts-expect-error
          initialValues={settings}
          onSubmit={saveSettings}
          setNavigationAnnouncement={setNavigationAnnouncement}
          {...props}
        />
      );
    },
  },
];

const fetchAccountSettings = (): Promise<EducatorAccountSettings> =>
  SettingsService.show('me', {fields: `${EDUCATOR_FIELDS},notificationSettings`});

const EducatorAccountSettings = () => (
  <AccountSettings<EducatorAccountSettings>
    tabs={tabs}
    fetchAccountSettings={fetchAccountSettings}
    availableNotificationSettings={NOTIFICATION_SETTINGS}
    saveSettings={(newSettings): Promise<EducatorAccountSettings> =>
      SettingsService.update('me', newSettings)
    }
  />
);

export default EducatorAccountSettings;
